import { PlanId } from 'domains/models/subscription/planId';
import SubscriptionFeature from 'domains/models/subscription/features';
import { CalendarViewType } from 'domains/models/event_type/calendarViewType';

export default class EventTypeCalendarViewTypeFeature extends SubscriptionFeature {
  validPlanId(calendarViewType: CalendarViewType) {
    if (
      [
        CalendarViewType.Week,
        CalendarViewType.TwoColumnMonthAccent,
        CalendarViewType.ListTime,
        CalendarViewType.GridTime,
      ].includes(calendarViewType)
    ) {
      return PlanId.Pro;
    } else {
      return PlanId.Free;
    }
  }

  isValid(planId: PlanId, calendarViewType: CalendarViewType) {
    return planId >= this.validPlanId(calendarViewType);
  }
}
